import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import { useState } from 'react';
import { Select } from '@outdoor-voices/ui';
import { useQuery } from 'urql';
import EverGreen from '../EverGreen';
import Fabric from '../Fabric/Card';
import { FABRICS_QUERY } from './queries';
import { NAV_HEIGHT } from '../../config/constants';
import Spinner from '../icons/Spinner';
import css from './Fabrics.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Fragment as _Fragment } from "react/jsx-runtime";

var Fabrics = function Fabrics() {
  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      currentFabric = _useState2[0],
      setCurrentFabric = _useState2[1];

  var _useQuery = useQuery({
    query: FABRICS_QUERY
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      fetching = _useQuery2$.fetching,
      error = _useQuery2$.error,
      data = _useQuery2$.data;

  if (fetching) {
    return /*#__PURE__*/_jsx("div", {
      className: css.fetching,
      "aria-busy": "true",
      children: /*#__PURE__*/_jsx(Spinner, {})
    });
  }

  if (error) {
    console.error(error);
    return /*#__PURE__*/_jsxs("div", {
      className: css.errorRoot,
      children: [/*#__PURE__*/_jsx("h2", {
        children: "Oops...Something went wrong."
      }), /*#__PURE__*/_jsx("p", {
        className: css.details,
        children: error.message
      })]
    });
  }

  var edges = data.fabrics.edges;
  var featuredFabrics = [];
  var otherFabrics = [];
  var mobileNavOptions = [];
  edges.map(function (edge) {
    var fabric = edge.node;
    mobileNavOptions.push({
      label: fabric.title,
      value: "fabric-".concat(fabric.id)
    });

    if (fabric.featured) {
      featuredFabrics.push( /*#__PURE__*/_createElement(Fabric, _objectSpread(_objectSpread({}, fabric), {}, {
        key: fabric.id,
        image: fabric.imageLanding
      })));
    } else {
      otherFabrics.push( /*#__PURE__*/_createElement(Fabric, _objectSpread(_objectSpread({}, fabric), {}, {
        key: fabric.id,
        other: true,
        image: fabric.imageLanding
      })));
    }
  });
  var hasFeatured = featuredFabrics.length > 0 ? true : false;

  var onMobileNavChange = function onMobileNavChange(event) {
    var id = event.target.value;
    var fabric = document.getElementById("".concat(id));
    var mobilePadding = 12;
    var top = fabric.offsetTop - NAV_HEIGHT - mobilePadding;
    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
    setCurrentFabric(id);
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: css.evergreen,
      children: /*#__PURE__*/_jsx(EverGreen, {
        center: true,
        large: true
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: css.mobileNav,
      children: [/*#__PURE__*/_jsx("div", {
        className: css.label,
        children: "All Fabrics"
      }), /*#__PURE__*/_jsx(Select, {
        label: "Select a Fabric",
        hideLabel: true,
        options: mobileNavOptions,
        name: "mobile-nav",
        onChange: onMobileNavChange,
        value: currentFabric
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: css.fabricsWrapper,
      children: [hasFeatured && /*#__PURE__*/_jsxs("div", {
        className: css.fabrics,
        children: [/*#__PURE__*/_jsx("h2", {
          className: css.header,
          children: "Featured Fabrics"
        }), /*#__PURE__*/_jsx("ul", {
          className: css.list,
          children: featuredFabrics
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: cc([css.fabrics, css.other]),
        children: [hasFeatured && /*#__PURE__*/_jsx("h2", {
          className: css.header,
          children: "More Fabrics"
        }), /*#__PURE__*/_jsx("ul", {
          className: css.list,
          children: otherFabrics
        })]
      })]
    })]
  });
};

export default Fabrics;